import { render } from "./shutdownList.vue?vue&type=template&id=67189d9e&scoped=true"
import script from "./shutdownList.vue?vue&type=script&lang=js"
export * from "./shutdownList.vue?vue&type=script&lang=js"

import "./shutdownList.vue?vue&type=style&index=0&id=67189d9e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67189d9e"

export default script